_getUserRequestCountry